<script setup lang="ts">
import { computed } from 'vue'
import type { StreamHudData } from '@/ui/stream-hud'
import type { AppLocale } from '@/i18n/messages'
import { streamMessages } from '@/i18n/stream'

const props = defineProps<{ data: StreamHudData; locale: AppLocale; variant: 'ice' | 'blocks' | 'tuner' | 'mushroom' }>()
const copy = computed(() => streamMessages[props.locale])
</script>

<template>
  <div class="adventure-progress sh-progress-group" :class="`adventure-progress-${variant}`" data-tier="1" data-stream-measure>
    <div class="adventure-track" :aria-label="`EXP ${data.expPercent}`">
      <i class="adventure-track-fill" :style="{ transform: `scaleX(${data.expRatio})` }" />
      <span class="adventure-track-marks" aria-hidden="true"><i v-for="mark in 7" :key="mark" /></span>
      <b class="adventure-track-pin" :style="{ left: `${data.expRatio * 100}%` }" aria-hidden="true" />
    </div>
    <div class="sh-progress-copy" data-stream-measure><strong data-stream-measure>{{ data.expPercent }}</strong><span data-stream-measure>{{ copy.eta }} <b>{{ data.eta }}</b></span></div>
  </div>
</template>
